import { Link } from 'react-router-dom';
import React from 'react';

export const WebHotelierLandingPage: React.FunctionComponent<{
	webhotelierId: string | undefined
}> = ({ webhotelierId }) => {
	return <div className="min-h-full bg-white">
		{/* Wrapper */}
		<div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
			{/* Logo */}
			<div className="mt-16 w-full inline-flex justify-center">
				<img className="h-10 w-auto" src="/assets/img/brand/rp-logo.svg" alt="RoomPulse" />
			</div>

			{/* Newsletter */}
			<div className="mt-6 overflow-y-scroll max-h-[70dvh] rounded-lg shadow-xl">
				<table className="nl-container" width="100%" border={0} cellPadding={0} cellSpacing={0} role="presentation"
							 style={{ backgroundColor: '#fff' }}>
					<tbody>
					<tr>
						<td>
							<table className="row row-2" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation" style={{ backgroundColor: '#494949' }}>
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation"
													 style={{ borderRadius: 0, color: '#000', width: '625px', margin: '0 auto' }} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '10px',
													paddingTop: '10px',
													verticalAlign: 'top',
												}}>
													<table className="image_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '218.75px' }}>
																		<a href="https://www.webhotelier.net/" target="_blank" style={{ outline: 'none' }}
																			 tabIndex={-1}><img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/5f7ed578-1133-40e8-91aa-f6024022efda/webhotelier-primalres_white.png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																			width="218.75" alt="" title="" height="auto" /></a>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-3" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation" style={{
								backgroundColor: '#2463eb',
								backgroundImage: 'url(https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/2526706c-b949-4581-9212-22a3864009b0/header_roompulse.png)',
								backgroundPosition: 'top center',
								backgroundRepeat: 'no-repeat',
								backgroundSize: 'auto',
							}}>
								<tbody>
								<tr>
									<td>
										<table className="row-content" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation" style={{
											backgroundSize: 'auto',
											borderRadius: '1px',
											color: '#000',
											width: '625px',
											margin: '0 auto',
										}} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '10px',
													paddingLeft: '10px',
													paddingRight: '10px',
													paddingTop: '10px',
													verticalAlign: 'top',
												}}>
													<div className="spacer_block block-1"
															 style={{ height: '60px', lineHeight: '60px', fontSize: '1px' }}></div>
													<table className="image_block block-2" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '151.25px' }}>
																		<img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/ba4b9d34-d817-461f-8a53-86ac63e2d9cc/Workspace App.png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																			width="151.25" alt="" title="" height="auto" />
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="image_block block-3" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad"
																	style={{ paddingTop: '15px', width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '302.5px' }}>
																		<a href="https://www.webhotelier.net/" target="_blank" style={{ outline: 'none' }}
																			 tabIndex={-1}><img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/eee9aded-e876-479a-b36f-53a758c3775e/Group 6451.png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																			width="302.5" alt="" title="" height="auto" /></a>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-4" width="100%" border={0} cellPadding={15} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad">
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '12px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#fff',
																		lineHeight: '1.2',
																	}}>
																		<p style={{
																			margin: 0,
																			fontSize: '14px',
																			textAlign: 'left',
																			letterSpacing: '3px',
																		}}>&nbsp;</p>
																		<p style={{
																			margin: 0,
																			fontSize: '14px',
																			textAlign: 'center',
																			letterSpacing: '3px',
																		}}><span style={{
																			wordBreak: 'break-word',
																			fontSize: '30px',
																			color: '#ffffff',
																		}}><strong><span style={{ wordBreak: 'break-word' }}><span
																			style={{ wordBreak: 'break-word' }}>Η νέα γενιά Rate Shopper<br />που αντικαθιστά το "Competitors"</span></span></strong></span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-4" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation" style={{ backgroundSize: 'auto' }}>
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation"
													 style={{ backgroundSize: 'auto', color: '#333', width: '625px', margin: '0 auto' }}
													 width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '10px',
													paddingTop: '25px',
													verticalAlign: 'top',
												}}>
													<table className="text_block block-1" width="100%" border={0} cellPadding={10} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad">
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		fontSize: '12px',
																		color: '#fff',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '20px', textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', fontSize: '20px' }}><strong><span
																			style={{ wordBreak: 'break-word', color: '#3c4043' }}>Ενεργοποιήστε από σήμερα το Roompulse, στο πλαίσιο της υφιστάμενης συνδρομής σας!</span></strong></span><span
																			style={{ wordBreak: 'break-word', fontSize: '20px' }}><strong><span style={{
																			wordBreak: 'break-word',
																			color: '#3c4043',
																		}}><br /></span></strong></span></p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '25px',
																paddingLeft: '60px',
																paddingRight: '60px',
																paddingTop: '10px',
															}}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '12px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#4a4a4a',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '16px', textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#3a3a3a' }}><span
																			style={{ wordBreak: 'break-word', fontSize: '16px' }}>Σας παρουσιάζουμε το Roompulse, το νέο workspace app του ομίλου μας με σύγχρονο design, εξελιγμένες λειτουργίες και <strong><span
																			style={{
																				wordBreak: 'break-word',
																				color: '#3972ec',
																			}}>δωρεάν μετάβαση</span></strong><span
																			style={{ wordBreak: 'break-word', color: '#3972ec' }}><span
																			style={{ wordBreak: 'break-word', color: '#000000' }}>.</span></span>&nbsp;Ένα ισχυρό εργαλείο </span></span><span
																			style={{ wordBreak: 'break-word', color: '#3a3a3a' }}><span
																			style={{ wordBreak: 'break-word', fontSize: '16px' }}>που θα βελτιστοποιήσει τη στρατηγική τιμολόγησής σας.</span></span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-5" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation"
													 style={{ borderRadius: 0, color: '#000', width: '625px', margin: '0 auto' }} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingTop: '5px',
													verticalAlign: 'top',
												}}>
													<table className="text_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '10px',
																paddingLeft: '10px',
																paddingRight: '10px',
																paddingTop: '20px',
															}}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '12px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#0132a3',
																		lineHeight: '1.2',
																	}}>
																		<p style={{
																			margin: 0,
																			fontSize: '12px',
																			textAlign: 'center',
																			letterSpacing: 'normal',
																		}}><span
																			style={{ wordBreak: 'break-word', fontSize: '20px', color: '#3a3a3a' }}><strong>Τι σας προσφέρει το Roompulse:</strong></span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-6" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation" style={{ backgroundColor: '#fff' }}>
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation" style={{
											backgroundColor: '#e1ebef',
											borderRadius: '20px 20px 0 0',
											color: '#000',
											width: '625px',
											margin: '0 auto',
										}} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingTop: '10px',
													verticalAlign: 'top',
												}}>
													<table className="text_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '5px',
																paddingLeft: '10px',
																paddingRight: '10px',
																paddingTop: '15px',
															}}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '14px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#555',
																		lineHeight: '1.5',
																	}}>
																		<p style={{
																			margin: 0,
																			fontSize: '14px',
																			textAlign: 'center',
																			letterSpacing: 'normal',
																		}}><span style={{ wordBreak: 'break-word', fontSize: '20px', color: '#3a3a3a' }}>Λειτουργίες στο πλαίσιο της<br />υφιστάμενης ετήσιας συνδρομής σας</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-7" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation" style={{
											backgroundColor: '#e1ebef',
											borderRadius: 0,
											color: '#333',
											width: '625px',
											margin: '0 auto',
										}} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="50%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingLeft: '20px',
													paddingRight: '20px',
													paddingTop: '40px',
													verticalAlign: 'top',
												}}>
													<table className="image_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad"
																	style={{ paddingRight: '10px', paddingTop: '5px', width: '100%', paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '163.5px' }}>
																		<a href="https://hotel.webhotelier.net/" target="_blank" style={{ outline: 'none' }}
																			 tabIndex={-1}><img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/f0b48a7d-68f8-441d-b914-f026e9b696d4/mobile.png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																			width="163.5" alt="Image" title="Image" height="auto" /></a>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '20px',
																paddingLeft: '10px',
																paddingRight: '10px',
																paddingTop: '20px',
															}}>
																<div style={{ fontFamily: 'sans-serif' }}>
																	<div style={{
																		fontSize: '14px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#555',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#3a3a3a' }}>Ανανεωμένο και φιλικό προς τον χρήστη περιβάλλον με <strong>mobile-friendly</strong> σχεδιασμό.</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
												<td className="column column-2" width="50%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingLeft: '20px',
													paddingRight: '20px',
													paddingTop: '40px',
													verticalAlign: 'top',
												}}>
													<table className="image_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '163.5px' }}>
																		<a href="https://hotel.webhotelier.net/" target="_blank" style={{ outline: 'none' }}
																			 tabIndex={-1}><img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/8aec66d7-e868-441b-99a0-d7acf5fd0cb7/mapping.png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																			width="163.5" alt="" title="" height="auto" /></a>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '20px',
																paddingLeft: '10px',
																paddingRight: '10px',
																paddingTop: '20px',
															}}>
																<div style={{ fontFamily: 'sans-serif' }}>
																	<div style={{
																		fontSize: '14px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#555',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#3a3a3a' }}>Λειτουργία <strong>Room Mapping</strong> για βελτιωμένη σύγκριση τιμών ανά τύπο δωματίων.</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-8" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation" style={{
											backgroundColor: '#e1ebef',
											borderRadius: 0,
											color: '#333',
											width: '625px',
											margin: '0 auto',
										}} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="50%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingLeft: '20px',
													paddingRight: '20px',
													paddingTop: '40px',
													verticalAlign: 'top',
												}}>
													<table className="image_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad"
																	style={{ paddingRight: '10px', paddingTop: '5px', width: '100%', paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '163.5px' }}>
																		<a href="https://hotel.webhotelier.net/" target="_blank" style={{ outline: 'none' }}
																			 tabIndex={-1}><img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/1735c3a3-4872-49cc-addf-b97618c8b180/02_parity.png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																			width="163.5" alt="Image" title="Image" height="auto" /></a>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '20px',
																paddingLeft: '10px',
																paddingRight: '10px',
																paddingTop: '20px',
															}}>
																<div style={{ fontFamily: 'sans-serif' }}>
																	<div style={{
																		fontSize: '14px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#555',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#3a3a3a' }}><strong>Parity: </strong>Σύγκριση τιμών της ιστοσελίδας σας με αυτές που εμφανίζονται σε κανάλια όπως Booking.com, Expedia και άλλα.</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
												<td className="column column-2" width="50%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingLeft: '20px',
													paddingRight: '20px',
													paddingTop: '40px',
													verticalAlign: 'top',
												}}>
													<table className="image_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '163.5px' }}>
																		<a href="https://hotel.webhotelier.net/" target="_blank" style={{ outline: 'none' }}
																			 tabIndex={-1}><img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/bc67b64f-7a5a-4675-bd51-01836fa23575/extranet_1742569919084png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																			width="163.5" alt="" title="" height="auto" /></a>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '20px',
																paddingLeft: '10px',
																paddingRight: '10px',
																paddingTop: '20px',
															}}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '14px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#555',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span style={{
																			wordBreak: 'break-word',
																			color: '#3a3a3a',
																		}}><strong>Chrome Extension<br /> </strong>Δείτε τις τιμές του ανταγωνισμού τη στιγμή που κάνετε αλλαγές στην webhotelier</span><span
																			style={{ wordBreak: 'break-word', color: '#3a3a3a' }}>, χωρίς να χρειάζεται να ανοίξετε ξεχωριστή εφαρμογή.</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-9" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation" style={{
											backgroundColor: '#e1ebef',
											borderRadius: '0 0 20px 20px',
											color: '#333',
											width: '625px',
											margin: '0 auto',
										}} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="50%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingLeft: '20px',
													paddingRight: '20px',
													paddingTop: '40px',
													verticalAlign: 'top',
												}}>
													<table className="image_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad"
																	style={{ paddingRight: '10px', paddingTop: '5px', width: '100%', paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '163.5px' }}>
																		<a href="https://hotel.webhotelier.net/" target="_blank" style={{ outline: 'none' }}
																			 tabIndex={-1}><img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/fa760d4c-97f7-420f-9f5d-47afffb24bbf/rate.png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																			width="163.5" alt="Image" title="Image" height="auto" /></a>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '20px',
																paddingLeft: '10px',
																paddingRight: '10px',
																paddingTop: '20px',
															}}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '12px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#555',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span style={{
																			wordBreak: 'break-word',
																			color: '#3a3a3a',
																		}}><strong>Rate Timeline:</strong> Δείτε πώς αλλάζουν οι τιμές την ημέρα και την περίοδο που σας ενδιαφέρει.</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
												<td className="column column-2" width="50%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingLeft: '20px',
													paddingRight: '20px',
													paddingTop: '40px',
													verticalAlign: 'top',
												}}>
													<table className="image_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad"
																	style={{ paddingRight: '10px', paddingTop: '5px', width: '100%', paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '163.5px' }}>
																		<a href="https://hotel.webhotelier.net/" target="_blank" style={{ outline: 'none' }}
																			 tabIndex={-1}><img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/ad43c40d-910c-45cb-b5c0-183c97dc0f31/speed.png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																			width="163.5" alt="Image" title="Image" height="auto" /></a>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '20px',
																paddingLeft: '10px',
																paddingRight: '10px',
																paddingTop: '20px',
															}}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '12px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#555',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#3a3a3a' }}><strong>Ταχύτερες </strong>ενημερώσεις δεδομένων για άμεση πληροφόρηση.&nbsp;</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-10" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation"
													 style={{ borderRadius: 0, color: '#000', width: '625px', margin: '0 auto' }} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%"
														style={{ fontWeight: 400, textAlign: 'left', verticalAlign: 'top' }}>
													<div className="spacer_block block-1"
															 style={{ height: '10px', lineHeight: '10px', fontSize: '1px' }}></div>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-11" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation"
													 style={{ borderRadius: '20px 20px 0 0', color: '#333', width: '625px', margin: '0 auto' }}
													 width={625}>
											<tbody>
											<tr className="reverse">
												<td className="column column-1 first" width="100%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingTop: '10px',
													verticalAlign: 'top',
												}}>
													<div>
														<table className="text_block block-1" width="100%" border={0} cellPadding={0}
																	 cellSpacing={0} role="presentation" style={{ wordBreak: 'break-word' }}>
															<tbody>
															<tr>
																<td className="pad"
																		style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '35px' }}>
																	<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																		<div style={{
																			fontSize: '14px',
																			fontFamily: 'Verdana,Geneva,sans-serif',
																			color: '#555',
																			lineHeight: '1.2',
																		}}>
																			<p style={{
																				margin: 0,
																				fontSize: '14px',
																				textAlign: 'center',
																				letterSpacing: 'normal',
																			}}><span
																				style={{ wordBreak: 'break-word', fontSize: '20px', color: '#3a3a3a' }}><strong>Πρόσθετες Premium λειτουργίες</strong></span>
																			</p>
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
														<table className="text_block block-2" width="100%" border={0} cellPadding={10}
																	 cellSpacing={0} role="presentation" style={{ wordBreak: 'break-word' }}>
															<tbody>
															<tr>
																<td className="pad">
																	<div style={{ fontFamily: 'sans-serif' }}>
																		<div style={{
																			fontSize: '14px',
																			fontFamily: 'Verdana,Geneva,sans-serif',
																			color: '#555',
																			lineHeight: '1.2',
																		}}>
																			<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span
																				style={{ wordBreak: 'break-word', color: '#3972ec' }}><em>- Με επιπλέον συνδρομή -</em></span>
																			</p>
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
													</div>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-12" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation"
													 style={{ borderRadius: 0, color: '#333', width: '625px', margin: '0 auto' }} width={625}>
											<tbody>
											<tr className="reverse">
												<td className="column column-1 first" width="33.333333333333336%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingLeft: '10px',
													paddingRight: '10px',
													paddingTop: '10px',
													verticalAlign: 'top',
												}}>
													<div>
														<table className="image_block block-1" width="100%" border={0} cellPadding={0}
																	 cellSpacing={0} role="presentation">
															<tbody>
															<tr>
																<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																	<div className="alignment" style={{
																		lineHeight: '10px',
																		maxWidth: 'fit-content',
																		marginLeft: 'auto',
																		marginRight: 'auto',
																	}}>
																		<div style={{ maxWidth: '47px' }}>
																			<img
																				src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/32b3dd3b-96f6-4992-89fc-57c7a75290d5/Intelligent-alerts.png"
																				style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																				width={47} alt="" title="" height="auto" />
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
														<table className="text_block block-2" width="100%" border={0} cellPadding={10}
																	 cellSpacing={0} role="presentation" style={{ wordBreak: 'break-word' }}>
															<tbody>
															<tr>
																<td className="pad">
																	<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																		<div style={{
																			fontSize: '14px',
																			fontFamily: 'Verdana,Geneva,sans-serif',
																			color: '#555',
																			lineHeight: '1.5',
																		}}>
																			<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span
																				style={{ wordBreak: 'break-word', fontSize: '14px', color: '#555555' }}><span
																				style={{ wordBreak: 'break-word', color: '#3a3a3a' }}><strong>Intelligent Alerts<br /></strong>Ειδοποιήσεις για</span><br /> <span
																				style={{
																					wordBreak: 'break-word',
																					color: '#3a3a3a',
																				}}>αλλαγές τιμών.</span><br /></span></p>
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
													</div>
												</td>
												<td className="column column-2" width="33.333333333333336%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingLeft: '10px',
													paddingRight: '10px',
													paddingTop: '10px',
													verticalAlign: 'top',
												}}>
													<table className="image_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div style={{ maxWidth: '47px' }}>
																		<img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/9dd98d6d-26c9-4594-be4c-85ed331e7cb8/Excel (1).png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }} width={47}
																			alt="" title="" height="auto" />
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={10} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad">
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '14px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#555',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#3a3a3a' }}><strong>Εξαγωγή Excel<br /> </strong>Ανάλυση δεδομένων εύκολα &amp; γρήγορα.</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
												<td className="column column-3 last" width="33.333333333333336%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '5px',
													paddingLeft: '10px',
													paddingRight: '10px',
													paddingTop: '10px',
													verticalAlign: 'top',
												}}>
													<div>
														<table className="image_block block-1" width="100%" border={0} cellPadding={0}
																	 cellSpacing={0} role="presentation">
															<tbody>
															<tr>
																<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																	<div className="alignment" style={{
																		lineHeight: '10px',
																		maxWidth: 'fit-content',
																		marginLeft: 'auto',
																		marginRight: 'auto',
																	}}>
																		<div style={{ maxWidth: '47.083px' }}>
																			<img
																				src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/8d3baf95-a7e3-438b-a475-b1a5039c410e/Country-Rates (1).png"
																				style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																				width="47.083" alt="" title="" height="auto" />
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
														<table className="text_block block-2" width="100%" border={0} cellPadding={10}
																	 cellSpacing={0} role="presentation" style={{ wordBreak: 'break-word' }}>
															<tbody>
															<tr>
																<td className="pad">
																	<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																		<div style={{
																			fontSize: '14px',
																			fontFamily: 'Verdana,Geneva,sans-serif',
																			color: '#555',
																			lineHeight: '1.5',
																		}}>
																			<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span style={{
																				wordBreak: 'break-word',
																				color: '#3a3a3a',
																			}}><strong>Country Rates<br /></strong>Προβολή τιμών<br /> ανά χώρα.</span></p>
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
													</div>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-13" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation"
													 style={{ borderRadius: 0, color: '#333', width: '625px', margin: '0 auto' }} width={625}>
											<tbody>
											<tr className="reverse">
												<td className="column column-1 first" width="50%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingLeft: '10px',
													paddingRight: '10px',
													paddingTop: '10px',
													verticalAlign: 'top',
												}}>
													<div>
														<table className="image_block block-1" width="100%" border={0} cellPadding={0}
																	 cellSpacing={0} role="presentation">
															<tbody>
															<tr>
																<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																	<div className="alignment" style={{
																		lineHeight: '10px',
																		maxWidth: 'fit-content',
																		marginLeft: 'auto',
																		marginRight: 'auto',
																	}}>
																		<div style={{ maxWidth: '58.5px' }}>
																			<img
																				src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/9e038c9a-91fc-49d3-b23e-adb478c1c1eb/genius-1.png"
																				style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																				width="58.5" alt="" title="" height="auto" />
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
														<table className="text_block block-2" width="100%" border={0} cellPadding={10}
																	 cellSpacing={0} role="presentation" style={{ wordBreak: 'break-word' }}>
															<tbody>
															<tr>
																<td className="pad">
																	<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																		<div style={{
																			fontSize: '14px',
																			fontFamily: 'Verdana,Geneva,sans-serif',
																			color: '#555',
																			lineHeight: '1.5',
																		}}>
																			<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span style={{
																				wordBreak: 'break-word',
																				color: '#3a3a3a',
																			}}><strong>Mobile &amp; Genius Rates<br /></strong>Σύγκριση προσφορών για μέλη και προσφορές για mobile συσκευές.</span>
																			</p>
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
													</div>
												</td>
												<td className="column column-2 last" width="50%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingLeft: '10px',
													paddingRight: '10px',
													paddingTop: '10px',
													verticalAlign: 'top',
												}}>
													<div>
														<table className="image_block block-1" width="100%" border={0} cellPadding={0}
																	 cellSpacing={0} role="presentation">
															<tbody>
															<tr>
																<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																	<div className="alignment" style={{
																		lineHeight: '10px',
																		maxWidth: 'fit-content',
																		marginLeft: 'auto',
																		marginRight: 'auto',
																	}}>
																		<div style={{ maxWidth: '58.5px' }}>
																			<img
																				src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/b78870eb-c5df-4f49-8318-1f7e4c6cd4f3/compare.png"
																				style={{ display: 'block', height: 'auto', border: 0, width: '100%' }}
																				width="58.5" alt="" title="" height="auto" />
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
														<table className="text_block block-2" width="100%" border={0} cellPadding={10}
																	 cellSpacing={0} role="presentation" style={{ wordBreak: 'break-word' }}>
															<tbody>
															<tr>
																<td className="pad">
																	<div style={{ fontFamily: 'sans-serif' }}>
																		<div style={{
																			fontSize: '12px',
																			fontFamily: 'Verdana,Geneva,sans-serif',
																			color: '#555',
																			lineHeight: '1.5',
																		}}>
																			<p style={{ margin: 0, fontSize: '12px', textAlign: 'center' }}><span
																				style={{ wordBreak: 'break-word', fontSize: '14px', color: '#3a3a3a' }}><strong>Extra Providers<br /> </strong>&nbsp;Σύγκριση πακέτων από Agoda και B2B (π.χ. Holiday Check).</span>
																			</p>
																		</div>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
													</div>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-14" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation"
													 style={{ borderRadius: 0, color: '#333', width: '625px', margin: '0 auto' }} width={625}>
											<tbody>
											<tr className="reverse">
												<td className="column column-1 first" width="100%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '30px',
													paddingTop: '15px',
													verticalAlign: 'top',
												}}>
													<div>
														<table className="button_block block-1" width="100%" border={0} cellPadding={10}
																	 cellSpacing={0} role="presentation">
															<tbody>
															<tr>
																<td className="pad">
																	<div className="alignment" style={{ textAlign: 'center' }}>
																		<a className="button" href="https://app.roompulse.io/sign-up" target="_blank"
																			 style={{
																				 backgroundColor: 'transparent',
																				 borderBottom: '3px dotted #2463eb',
																				 borderLeft: '3px dotted #2463eb',
																				 borderRadius: '0px',
																				 borderRight: '3px dotted #2463eb',
																				 borderTop: '3px dotted #2463eb',
																				 color: '#353535',
																				 display: 'inline-block',
																				 fontFamily: 'Verdana, Geneva, sans-serif',
																				 fontSize: '14px',
																				 fontWeight: 700,
																				 paddingBottom: '5px',
																				 paddingTop: '5px',
																				 textAlign: 'center',
																				 textDecoration: 'none',
																				 width: 'auto',
																				 wordBreak: 'keep-all',
																			 }}><span style={{
																			wordBreak: 'break-word',
																			paddingLeft: '20px',
																			paddingRight: '20px',
																			fontSize: '14px',
																			display: 'inline-block',
																			letterSpacing: 'normal',
																		}}><span
																			style={{ wordBreak: 'break-word', lineHeight: '21px' }}>Κάντε κλικ <u>εδώ</u> για να δοκιμάσετε <br />τις premium λειτουργίες δωρεάν για 14 ημέρες</span></span></a>
																	</div>
																</td>
															</tr>
															</tbody>
														</table>
													</div>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-15" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation" style={{
											backgroundColor: '#3972ec',
											borderRadius: '20px 20px 0 0',
											color: '#333',
											width: '625px',
											margin: '0 auto',
										}} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%"
														style={{ fontWeight: 400, textAlign: 'left', paddingTop: '10px', verticalAlign: 'top' }}>
													<table className="text_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '15px',
																paddingLeft: '50px',
																paddingRight: '50px',
																paddingTop: '25px',
															}}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '14px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#555',
																		lineHeight: '1.5',
																	}}>
																		<p style={{
																			margin: 0,
																			fontSize: '14px',
																			textAlign: 'center',
																			letterSpacing: 'normal',
																		}}><strong><span
																			style={{ wordBreak: 'break-word', fontSize: '20px', color: '#ffffff' }}>Για τη μετάβασή σας στο<br /> Roompulse αρκεί μόνο ένα κλικ!</span></strong>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-16" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation" style={{
											backgroundColor: '#3972ec',
											borderRadius: 0,
											color: '#333',
											width: '625px',
											margin: '0 auto',
										}} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%"
														style={{ fontWeight: 400, textAlign: 'left', paddingTop: '10px', verticalAlign: 'top' }}>
													<table className="image_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation">
														<tbody>
														<tr>
															<td className="pad" style={{ width: '100%', paddingRight: 0, paddingLeft: 0 }}>
																<div className="alignment" style={{
																	lineHeight: '10px',
																	maxWidth: 'fit-content',
																	marginLeft: 'auto',
																	marginRight: 'auto',
																}}>
																	<div className="fullWidth" style={{ maxWidth: '469px' }}>
																		<a href="https://hotel.webhotelier.net/" target="_blank" style={{ outline: 'none' }}
																			 tabIndex={-1}><img
																			src="https://gallery.fwfmgallery.com/eb43c49a-ae3d-3cca-b9ff-eb45b6a92f80/files/20cd7425-664a-423f-9293-fdf47188445a/Dell_extranet (2).png"
																			style={{ display: 'block', height: 'auto', border: 0, width: '100%' }} width={469}
																			alt="" title="" height="auto" /></a>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad"
																	style={{ paddingLeft: '60px', paddingRight: '30px', paddingTop: '20px' }}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		fontSize: '12px',
																		color: '#483a7e',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#ffffff', fontSize: '14px' }}>1.Μπείτε στο extranet της webhotelier.</span>
																		</p>
																		<p style={{ margin: 0, textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#ffffff', fontSize: '14px' }}>2. Κάντε κλικ στο Roompulse.</span>
																		</p>
																		<p style={{ margin: 0, textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#ffffff', fontSize: '14px' }}>2. Επιλέξτε τους competitors που θέλετε να παρακολουθείτε.</span>
																		</p>
																		<p style={{ margin: 0, textAlign: 'center' }}>&nbsp;</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-3" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad" style={{
																paddingBottom: '20px',
																paddingLeft: '40px',
																paddingRight: '40px',
																paddingTop: '20px',
															}}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		fontSize: '12px',
																		color: '#483a7e',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', fontSize: '20px' }}><span
																			style={{ wordBreak: 'break-word', color: '#ffffff' }}>Είστε έτοιμοι!</span></span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-17" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation" style={{
											backgroundColor: '#3972ec',
											borderRadius: '0 0 20px 20px',
											color: '#333',
											width: '625px',
											margin: '0 auto',
										}} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%"
														style={{ fontWeight: 400, textAlign: 'left', paddingTop: '10px', verticalAlign: 'top' }}>
													<table className="text_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad"
																	style={{ paddingBottom: '40px', paddingLeft: '40px', paddingRight: '40px' }}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		fontSize: '12px',
																		color: '#483a7e',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#ffffff', fontSize: '14px' }}>Εξερευνήστε τις νέες δυνατότητες,<br />αξιοποιήστε τις βασικές λειτουργίες και ανακαλύψτε τις premium.</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-18" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation">
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation"
													 style={{ borderRadius: '0 0 20px 20px', color: '#333', width: '625px', margin: '0 auto' }}
													 width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '30px',
													paddingTop: '30px',
													verticalAlign: 'top',
												}}>
													<table className="text_block block-1" width="100%" border={0} cellPadding={0} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad"
																	style={{ paddingBottom: '10px', paddingLeft: '10px', paddingRight: '10px' }}>
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		fontSize: '12px',
																		color: '#483a7e',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, textAlign: 'center' }}><span style={{
																			wordBreak: 'break-word',
																			color: '#3a3a3a',
																			fontSize: '20px',
																		}}><strong><span style={{ wordBreak: 'break-word' }}>Χρειάζεστε περισσότερες πληροφορίες;</span></strong></span>
																		</p>
																		<p style={{ margin: 0, textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', color: '#3a3a3a', fontSize: '14px' }}>Κλείστε ένα online ραντεβού με το support της Roompulse.</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="button_block block-2" width="100%" border={0} cellPadding={10}
																 cellSpacing={0} role="presentation">
														<tbody>
														<tr>
															<td className="pad">
																<div className="alignment" style={{ textAlign: 'center' }}>
																	<a className="button"
																		 href="https://calendly.com/dionisis-roompulse/competitors-switch" target="_blank"
																		 style={{
																			 backgroundColor: '#494949',
																			 borderBottom: '0px solid transparent',
																			 borderLeft: '0px solid transparent',
																			 borderRadius: '4px',
																			 borderRight: '0px solid transparent',
																			 borderTop: '0px solid transparent',
																			 color: '#ffffff',
																			 display: 'inline-block',
																			 fontFamily: 'Verdana, Geneva, sans-serif',
																			 fontSize: '14px',
																			 fontWeight: 700,
																			 paddingBottom: '5px',
																			 paddingTop: '5px',
																			 textAlign: 'center',
																			 textDecoration: 'none',
																			 width: 'auto',
																			 wordBreak: 'keep-all',
																		 }}><span style={{
																		wordBreak: 'break-word',
																		paddingLeft: '20px',
																		paddingRight: '20px',
																		fontSize: '14px',
																		display: 'inline-block',
																		letterSpacing: 'normal',
																	}}><span
																		style={{ wordBreak: 'break-word', lineHeight: '28px' }}>Ραντεβού</span></span></a>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
							<table className="row row-19" align="center" width="100%" border={0} cellPadding={0} cellSpacing={0}
										 role="presentation" style={{ backgroundColor: '#494949' }}>
								<tbody>
								<tr>
									<td>
										<table className="row-content stack" align="center" border={0} cellPadding={0} cellSpacing={0}
													 role="presentation" style={{ color: '#333', width: '625px', margin: '0 auto' }} width={625}>
											<tbody>
											<tr>
												<td className="column column-1" width="100%" style={{
													fontWeight: 400,
													textAlign: 'left',
													paddingBottom: '30px',
													paddingTop: '30px',
													verticalAlign: 'top',
												}}>
													<table className="social_block block-1" width="100%" border={0} cellPadding={0}
																 cellSpacing={0} role="presentation">
														<tbody>
														<tr>
															<td className="pad" style={{ textAlign: 'center', paddingRight: 0, paddingLeft: 0 }}>
																<div className="alignment">
																	<table className="social-table" width="111px" border={0} cellPadding={0}
																				 cellSpacing={0} role="presentation" style={{ display: 'inline-block' }}>
																		<tbody>
																		<tr>
																			<td style={{ padding: '0 5px 0 0' }}><a
																				href="https://www.linkedin.com/company/webhotelier/" target="_blank"><img
																				src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/linkedin@2x.png"
																				width={32} height="auto" alt="LinkedIn" title="LinkedIn"
																				style={{ display: 'block', height: 'auto', border: 0 }} /></a></td>
																			<td style={{ padding: '0 5px 0 0' }}><a
																				href="https://www.facebook.com/webhotelier" target="_blank"><img
																				src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/facebook.png"
																				width={32} height="auto" alt="Facebook" title="Facebook"
																				style={{ display: 'block', height: 'auto', border: 0 }} /></a></td>
																			<td style={{ padding: '0 5px 0 0' }}><a
																				href="https://www.instagram.com/webhotelier_primalres/" target="_blank"><img
																				src="https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-circle-white/instagram@2x.png"
																				width={32} height="auto" alt="Instagram" title="Instagram"
																				style={{ display: 'block', height: 'auto', border: 0 }} /></a></td>
																		</tr>
																		</tbody>
																	</table>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
													<table className="text_block block-2" width="100%" border={0} cellPadding={10} cellSpacing={0}
																 role="presentation" style={{ wordBreak: 'break-word' }}>
														<tbody>
														<tr>
															<td className="pad">
																<div style={{ fontFamily: 'Verdana,sans-serif' }}>
																	<div style={{
																		fontSize: '12px',
																		fontFamily: 'Verdana,Geneva,sans-serif',
																		color: '#d0d0d0',
																		lineHeight: '1.5',
																	}}>
																		<p style={{ margin: 0, fontSize: '14px', textAlign: 'center' }}><span
																			style={{ wordBreak: 'break-word', fontSize: '12px', color: '#d0d0d0' }}><a
																			href="https://www.webhotelier.net/" target="_blank"
																			style={{ textDecoration: 'underline', color: '#d0d0d0' }} rel="noopener"><span
																			style={{ wordBreak: 'break-word' }}>webhotelier | primalres</span></a>&nbsp; &nbsp;© All rights reserved 2025</span>
																		</p>
																	</div>
																</div>
															</td>
														</tr>
														</tbody>
													</table>
												</td>
											</tr>
											</tbody>
										</table>
									</td>
								</tr>
								</tbody>
							</table>
						</td>
					</tr>
					</tbody>
				</table>
			</div>
			{/* CTA button */}
			{!!webhotelierId && <div className="mt-16 inline-flex justify-center w-full">
				<Link to={'/oauth2/redirect?webhotelierId=' + webhotelierId}
							className="btn btn-primary text-base px-8 py-4 font-semibold" title="Click to continue">
					Continue to Roompulse &rarr;
				</Link>
			</div>}
		</div>
	</div>;
};